import React, {Component} from 'react';
import cx from 'classnames';

import SelectedMember from './selected_member';
import TeamMemberSelect from './team_member_select';
import TeamMemberHover from './team_member_hover';

import teamMemberInfo from './team_member_info.js';

export default class MeetTheTeam extends Component {
    constructor(){
        super();
        this.handleSelect = this.handleSelect.bind(this);
        this.displaySelectedMember = this.displaySelectedMember.bind(this);
        this.diplaySelectTeamMembers = this.diplaySelectTeamMembers.bind(this);
        this.displayHoverTeamMembers = this.displayHoverTeamMembers.bind(this);
        this.state = {
            selectedMemberIdx: 0
        }
    }

    handleSelect(index){
        this.setState({
            selectedMemberIdx: index
        });
    }

    displaySelectedMember(){
        const {selectedMemberIdx} = this.state;
        const member = teamMemberInfo[selectedMemberIdx];

        return <SelectedMember
            name={member.name}
            title={member.title}
            info={member.info}
            imgPath={member.imgPath}
            logoPath={member.logoPath} />
    }

    diplaySelectTeamMembers(){
        const {selectedMemberIdx} = this.state;

        return teamMemberInfo.map((member, idx) => {
            const isActive = idx === selectedMemberIdx ? true : false;

            return <TeamMemberSelect
                key={idx}
                name={member.name}
                title={member.title}
                info={member.info}
                imgPath={member.imgPath}
                logoPath={member.logoPath}
                isActive={isActive}
                selectMember={() => { return this.handleSelect(idx) }} />
        });
    }

    displayHoverTeamMembers(){
        return teamMemberInfo.map((member, idx) => {
            return <TeamMemberHover
                key={idx}
                name={member.name}
                title={member.title}
                info={member.info}
                imgPath={member.imgPath}
                logoPath={member.logoPath} />
        });
    }

    render(){
        const {isMobile, displayStatic, page} = this.props;
        const selectedMember = this.displaySelectedMember();
        const selectTeamMembers = this.diplaySelectTeamMembers();
        const hoverTeamMembers = this.displayHoverTeamMembers();
        const classnames = cx('gr-12', 'meet-the-team', `meet-the-team-${page}`);
        const meetTheTeamBodyClassnames = cx('gr-centered', 'meet-the-team-body', {
            'meet-the-team-body-web-static': displayStatic && !isMobile
        });

        return(
            <div className={classnames}>
                <div className='row'>
                    <div className='gr-12 meet-the-team-text'>
                        <h1>Meet the team</h1>
                        <p>The best minds in technology combined forces to build the best tool in content marketing.</p>
                    </div>
                    <div className={meetTheTeamBodyClassnames}>
                        <div className='team-members-select-grid'>
                            <div className='grid-center'>
                                {selectedMember}
                                <div className='team-members-select-container'>
                                    {selectTeamMembers}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/meet_the_team/index.js